import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";

@Component
export default class FeedItemMixin extends Vue {
  @Prop({ type: Object, required: true })
  public readonly contentFeed!: ContentFeed;

  public mounted() {
    this.$emit("mounted", this.$el);
  }
}
